export default __webpack_public_path__ + "static/media/help.4edb1e58.svg";